import { Text } from "@solomon-apps/shared/src/components/ui/text";
import { RetryIcon } from "@solomon-labs/design/components/icons";
import { Button } from "@solomon-labs/design/components/ui";
import React from "react";

/**
 * A form's inline save error (never a toast), with "Retry" beside it when the
 * save never reached the server (`isClientConnectionError`): the console's
 * link button (link + underline), the retry glyph trailing. Shared by the
 * add-destination form and the Add a Position destination picker.
 */
export function FormErrorRetry({
    error,
    onRetry,
    busy = false,
    className
}: {
    error: string;
    /** Resends the same save. Omit when retrying as-is can't help. */
    onRetry?: () => void;
    /** A save is in flight: Retry goes inert. */
    busy?: boolean;
    className?: string;
}): React.ReactElement {
    return (
        <div
            className={`flex flex-wrap items-baseline gap-1 ${className ?? ""}`}
        >
            <Text variant="label" className="text-error-base">
                {error}
            </Text>
            {onRetry ? (
                <Button
                    variant="link-error"
                    interaction="underline"
                    // 3xs is `label`, the error line's own variant, at every width.
                    size="3xs"
                    trailing={<RetryIcon />}
                    onClick={onRetry}
                    disabled={busy}
                >
                    Retry
                </Button>
            ) : null}
        </div>
    );
}
